import {REVENUE_TABLE, GROSSMARGIN_TABLE, EBITDAMARGIN_TABLE,
  OPERATINGMARGIN_TABLE, NETPROFITMARGIN_TABLE, INTERESTCOVERAGERATIO_TABLE,
  LEVERAGERELATIVETOEBITDA_TABLE, LEVERAGERELATIVETOEQUITY_TABLE, UPDATEASSESMENT,
  TANGIBLENETWORTHCOVERAABLE_TABLE, CURRENTRATIO_TABLE, GETSINGLEASSESMENT, EDITASSESMENT,
  QUICKRATIO_TABLE, CURRENTASSETSLIQUIDATION_TABLE, GETASSESMENT, UPDATEASSESSMENTCOUNTER,
  CASHCONVERSIONCYCLE_TABLE, GETRATINGASSESSMENT, POSTASSESMENT, DELETE_FINANCIAL_ASSESSMENT,
  GETCOMBINEDASSESSMENT, GETLIQUIDITYASSESSMENT, GETASSESMENTSCALE} from '../actions/assesment'
import { RepositoryFactory } from '../repositories/RepositoryFactory'
import { store } from '../store/store'
const Repository = RepositoryFactory.get('assesment')

const state = {
  Revenue: {},
  grossMargin: {},
  ebitdaMargin: {},
  operatingMargin: {},
  netProfitMargin: {},
  interestCoverageRatio: {},
  leverageRelativeToEbitda: {},
  leverageRelativeToEquity: {},
  tangibleNetWorthCoveraable: {},
  currentRatio: {},
  quickRatio: {},
  currentAssetsLiquidation: {},
  cashConversionCycle: {},
  ratingAssessment: {},
  combinedAssessment: {},
  liquidityAssessment: {},
  assesmentID: null
}
const actions = {
  [REVENUE_TABLE]: ({commit}) => {
    return Repository.getRevenueTable().then((result) => {
      let revenue = result.data
      commit(REVENUE_TABLE, {'data': revenue})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [GROSSMARGIN_TABLE]: ({commit}) => {
    return Repository.getGrossMarginTable().then(result => {
      commit(GROSSMARGIN_TABLE, {'data': result.data})
    }).catch(error => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [EBITDAMARGIN_TABLE]: ({commit}) => {
    return Repository.getEbitdaMarginTable().then((result) => {
      commit(EBITDAMARGIN_TABLE, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [OPERATINGMARGIN_TABLE]: ({commit}) => {
    return Repository.getOperatingMarginTable().then((result) => {
      commit(OPERATINGMARGIN_TABLE, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [NETPROFITMARGIN_TABLE]: ({commit}) => {
    return Repository.getnetProfitMarginTable().then((result) => {
      commit(NETPROFITMARGIN_TABLE, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [INTERESTCOVERAGERATIO_TABLE]: ({commit}) => {
    return Repository.getinterestCoverageRatioTable().then((result) => {
      commit(INTERESTCOVERAGERATIO_TABLE, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [LEVERAGERELATIVETOEBITDA_TABLE]: ({commit}) => {
    return Repository.getleverageRelativeToEBITDATable().then((result) => {
      commit(LEVERAGERELATIVETOEBITDA_TABLE, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [LEVERAGERELATIVETOEQUITY_TABLE]: ({commit}) => {
    return Repository.getleverageRelativeToEquityTable().then((result) => {
      commit(LEVERAGERELATIVETOEQUITY_TABLE, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [TANGIBLENETWORTHCOVERAABLE_TABLE]: ({commit}) => {
    return Repository.gettangibleNetWorthCoverageTable().then((result) => {
      commit(TANGIBLENETWORTHCOVERAABLE_TABLE, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [CURRENTRATIO_TABLE]: ({commit}) => {
    return Repository.getcurrentRatioTable().then((result) => {
      commit(CURRENTRATIO_TABLE, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [QUICKRATIO_TABLE]: ({commit}) => {
    return Repository.getquickRatioTable().then((result) => {
      commit(QUICKRATIO_TABLE, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [CURRENTASSETSLIQUIDATION_TABLE]: ({commit}) => {
    return Repository.getcurrentAssetsLiquidationTable().then((result) => {
      commit(CURRENTASSETSLIQUIDATION_TABLE, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [CASHCONVERSIONCYCLE_TABLE]: ({commit}) => {
    return Repository.getcashConversionCycleTable().then((result) => {
      commit(CASHCONVERSIONCYCLE_TABLE, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [GETRATINGASSESSMENT]: ({commit}) => {
    return Repository.getRatingAssessment().then((result) => {
      commit(GETRATINGASSESSMENT, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [GETCOMBINEDASSESSMENT]: ({commit}) => {
    return Repository.getcombinedAssessment().then((result) => {
      commit(GETCOMBINEDASSESSMENT, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [GETLIQUIDITYASSESSMENT]: ({commit}) => {
    return Repository.getliquidityAssessment().then((result) => {
      commit(GETLIQUIDITYASSESSMENT, {'data': result.data})
    }).catch((error) => {
      commit('NOTIFICATION', error.response.data)
    })
  },
  [GETASSESMENTSCALE]: () => {
    return Repository.getAssmentScale()
  },
  [POSTASSESMENT]: async ({commit}, postdata) => {
    let output = await Repository.postAssesment(postdata)
    return output
  },
  [UPDATEASSESMENT]: async ({commit}, postdata) => {
    let output = await Repository.updateAssesment(postdata)
    return output
  },
  [GETASSESMENT]: ({commit}, data) => {
    return Repository.getAssesments(data)
  },
  [GETSINGLEASSESMENT]: async ({commit}, data) => {
    let assessment = await Repository.getSingleAssesments(data)
    return assessment
  },
  [EDITASSESMENT]: async ({commit}, data) => {
    let assessment = await Repository.editAssesment(data)
    return assessment.data
  },
  [UPDATEASSESSMENTCOUNTER]: async ({commit}, data) => {
    try {
      let result = await Repository.updateAssessmentCounter()
      store.dispatch('UPDATELOGGEDINUSER', result.data)
      commit(UPDATEASSESSMENTCOUNTER, result.data)
      return result.data
    } catch (error) {
      commit('NOTIFICATION', error.data)
      return error.data
    }
  },
  [DELETE_FINANCIAL_ASSESSMENT]: async ({commit}, data) => {
    const output = await Repository.deleteFinancialAssessment(data)
    return output['data']
  }
}
const mutations = {
  [REVENUE_TABLE]: (state, result) => {
    // console.log(result)
    state.Revenue = result.data
  },
  [GROSSMARGIN_TABLE]: (state, result) => {
    // console.log(result)
    state.grossMargin = result.data
  },
  [EBITDAMARGIN_TABLE]: (state, result) => {
    // console.log('inside commit', result)
    state.ebitdaMargin = result.data
  },
  [OPERATINGMARGIN_TABLE]: (state, result) => {
    // console.log('inside commit', result)
    state.operatingMargin = result.data
  },
  [NETPROFITMARGIN_TABLE]: (state, result) => {
    // console.log('inside commit', result)
    state.netProfitMargin = result.data
  },
  [INTERESTCOVERAGERATIO_TABLE]: (state, result) => {
    // console.log('inside commit', result)
    state.interestCoverageRatio = result.data
  },
  [LEVERAGERELATIVETOEBITDA_TABLE]: (state, result) => {
    // console.log('inside commit', result)
    state.leverageRelativeToEbitda = result.data
  },
  [LEVERAGERELATIVETOEQUITY_TABLE]: (state, result) => {
    // console.log('inside commit', result)
    state.leverageRelativeToEquity = result.data
  },
  [TANGIBLENETWORTHCOVERAABLE_TABLE]: (state, result) => {
    // console.log('inside commit', result)
    state.tangibleNetWorthCoveraable = result.data
  },
  [CURRENTRATIO_TABLE]: (state, result) => {
    // console.log('inside commit', result)
    state.currentRatio = result.data
  },
  [QUICKRATIO_TABLE]: (state, result) => {
    // console.log('inside commit', result)
    state.quickRatio = result.data
  },
  [CURRENTASSETSLIQUIDATION_TABLE]: (state, result) => {
    // console.log('inside commit', result)
    state.currentAssetsLiquidation = result.data
  },
  [CASHCONVERSIONCYCLE_TABLE]: (state, result) => {
    // console.log('inside commit', result)
    state.cashConversionCycle = result.data
  },
  [GETRATINGASSESSMENT]: (state, result) => {
    // console.log('inside commit rating assessment', result)
    state.ratingAssessment = result.data
  },
  [GETCOMBINEDASSESSMENT]: (state, result) => {
    // console.log('inside commit', result)
    state.combinedAssessment = result.data
  },
  [GETLIQUIDITYASSESSMENT]: (state, result) => {
    // console.log('inside commit', result)
    state.liquidityAssessment = result.data
  },
  [POSTASSESMENT]: (state, result) => {
    state.assesmentID = result.data
  },
  [GETASSESMENT]: (state, result) => {
  },
  [UPDATEASSESSMENTCOUNTER]: (state, data) => {
    // rodo
  }

}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/modules/assessment.js